import { Create } from "@refinedev/mui";
import { Box, TextField } from "@mui/material";
import { useForm } from "@refinedev/react-hook-form";
import { IResourceComponentsProps } from "@refinedev/core";

export const CategoryCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm({
    refineCoreProps: {
      errorNotification: (error) => {
        return {
          message: error?.message?.includes("duplicate key value")
            ? "Category already exist"
            : error?.message?.includes("violates foreign key constraint")
            ? "The following category is used in the platform and can not be deleted!"
            : "Oops! something went wrong, please try later.",
          type: "error",
        };
      },
    },
  });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("categoryName", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.categoryName}
          helperText={(errors as any)?.categoryName?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Category Name"
          name="categoryName"
        />
      </Box>
    </Create>
  );
};
